import { render, staticRenderFns } from "./OnBoard.vue?vue&type=template&id=241c7106&scoped=true"
import script from "./OnBoard.vue?vue&type=script&setup=true&lang=js"
export * from "./OnBoard.vue?vue&type=script&setup=true&lang=js"
import style0 from "./OnBoard.vue?vue&type=style&index=0&id=241c7106&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "241c7106",
  null
  
)

export default component.exports